<template>
    <div class="rest_list__header_item" :class="classItem">
        <div class="rest_list__header_item_wrapper">
            <div class="rest_list__header_item_block_text cursor_pointer" @click.prevent="clickItem">
                <div class="rest_list__header_item_text">
                    {{ nameItem }}
                </div>
            </div>
            <div class="rest_list__header_item_select">
            </div>
        </div>
    </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";

const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})

export default {
    name: "rest_list_header_item",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    emits: ['select_item_header'],
    components: {},
    mixins: [],
    methods: {
        clickItem() {
            this.$emit('select_item_header', this.item);
        },
    },
    computed: {
        ...mAggregators([
            'activeAggregator',
        ]),
        classItem() {
            if (this.item.type_data === 'aggregator' || this.item.type_data === 'delivery') {
                return {'active': this.item === this.activeAggregator};
            } else if (this.item.isSelect) {
                return {'active': true};
            }
            return {'active': false};
        },
        nameItem() {
            if (this.item.const) {
                return `${this.__t(this.item.const)}`;
            } else if (this.item.name) {
                return this.item.name;
            } else if (this.item.title) {
                return this.item.title;
            }
            return 'No name';
        }
    }
}
</script>
